import NavigationDots from './NavigationDots'

export default NavigationDots
